"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaQuery = exports.media = exports.breakpoints = void 0;
require("./media.types");
exports.breakpoints = {
    DESKTOP: 720,
    DESKTOP_LARGE: 1200,
};
exports.media = {
    desktop: '@media (min-width: 720px)',
    desktopLarge: '@media (min-width: 1200px)',
};
exports.mediaQuery = {
    isDesktop: '(min-width: 720px)',
    isDesktopLarge: '(min-width: 1200px)',
};
